import { faFilter } from "@jewlr/pro-regular-svg-icons/faFilter"
import PropTypes from "prop-types"

import withFilters from "areas/collection/hoc/with-filters"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

import HolidayDeliveryToggle from "./holiday-delivery-toggle"
import SortMenu from "./sort-menu"

const InternalFilterHeader = ({
  collectionFilters,
  disableFilters,
  disableSort,
  toggleFilter,
}) => {
  return (
    <>
      <Divider />
      <div className="relative">
        <div
          className={`flex items-center ${
            disableFilters ? "justify-end" : "justify-between"
          }`}
        >
          {!disableFilters && (
            <Button
              className="px-4"
              data-cy="collection-filter-icon-mobile"
              onClick={() => toggleFilter(true)}
              size="sm"
              variant="tertiary"
            >
              <FontAwesomeIcon className="mr-6" icon={faFilter} />
              Filter
            </Button>
          )}
          {!disableSort && <SortMenu />}
        </div>
      </div>
      <Divider />
      {(collectionFilters || [])
        .filter((filter) => filter.delivery_category)
        .map((filter, index) => (
          <HolidayDeliveryToggle
            filter={filter}
            key={`${filter.name}${index}`}
          />
        ))}
    </>
  )
}

InternalFilterHeader.propTypes = {
  collectionFilters: PropTypes.array,
  disableFilters: PropTypes.bool,
  disableSort: PropTypes.bool,
  toggleFilter: PropTypes.func,
}

const FilterHeader = withFilters(InternalFilterHeader)

export default FilterHeader
